import styled from 'styled-components';
import { animated } from 'react-spring';

import { breakpoints, colors, spacing } from '../../constants';

export const Header = styled(animated.h2)`
    padding: ${spacing.md} 0;
    font-weight: 300;
    text-align: center;
    color: ${colors.greenDark};

    strong {
        font-weight: 600;
    }

    && {
        font-size: 28px;
        line-height: 1.3;
    }

    @media (${breakpoints.mediumMin}) {
        max-width: 900px;
    }

    && {
        @media (${breakpoints.largeMin}) {
            font-size: 34px;
        }
    }
`;
